import {
  ConsoleTransportConfig,
  MetaPixelEvent,
  MetaPixelPayload,
  Transport,
} from '../meta-pixel.types';

export const createConsoleTransport = (): Transport => {
  let _enabled = true;
  let _prefix = '[Meta Pixel]';

  return {
    name: 'console',

    init(config: ConsoleTransportConfig): void {
      _enabled = config.enabled ?? true;
      _prefix = config.prefix ?? _prefix;
    },

    track(eventName: MetaPixelEvent, payload?: MetaPixelPayload): void {
      if (!_enabled) return;

      if (payload && Object.keys(payload).length > 0) {
        console.log(_prefix, eventName, payload);
        return;
      }

      console.log(_prefix, eventName);
    },
  };
};
